import React, { useState, useEffect, useRef } from "react";
import Header from "../Header/Header";
import "./CompanyPage.css";
import { FaLinkedin } from "react-icons/fa";
import { IoMdDownload } from "react-icons/io";
import jsPDF from "jspdf";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import dayjs from "dayjs";
import axios from "axios";
import { MdOutlineArrowBackIos } from "react-icons/md";

import {
  MdCheckCircle,
  MdRadioButtonUnchecked,
  MdErrorOutline,
} from "react-icons/md";
import { MdEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import Swal from "sweetalert2";
import { MdCall } from "react-icons/md";
import { MdEmail } from "react-icons/md";
import ReactModal from "react-modal";
import { IoMdArrowRoundBack } from "react-icons/io";
import { MdGroups, MdNotificationsActive } from "react-icons/md";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

function CompanyPage() {
  const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

  const { listname, id } = useParams();

  const popupRef = useRef(null);

  const handleOutsideClick = (e) => {
    if (popupRef.current && !popupRef.current.contains(e.target)) {
      setShowPopup(false);
    }
  };

  const [selectedTab, setSelectedTab] = useState("Overview");
  const [companyDetail, setCompanyDetail] = useState();
  const [showPopup, setShowPopup] = useState(false);
  const [reminders, setReminders] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedReminder, setSelectedReminder] = useState(null);
  const [modalMode, setModalMode] = useState("view");
  const [Id, setId] = useState("");
  const [description, setDescription] = useState("");
  const [reminderTime, setReminderTime] = useState("");
  const [type, setType] = useState("");
  const [subject, setSubject] = useState("");

  // const [completedTasks, setCompletedTasks] = useState([]);
  const [notes, setNotes] = useState("");
  const [note, setNote] = useState([]);
  const [editNote, setEditNote] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedList, setSelectedList] = useState([]);
  const [list, setList] = useState([]);
  const [selectedLeadStatus, setSelectedLeadStatus] = useState("");
  const [selectedDND, setSelectedDND] = useState("");
  const [selectedSource, setSelectedSource] = useState("");
  const [score, setScore] = useState("");
  const [dealName, setDealName] = useState("");
  const [dealValue, setDealValue] = useState("");
  const [wonValue, setWonValue] = useState("");
  const [lostValue, setLostValue] = useState("");
  const [leadPeriod, setLeadPeriod] = useState("");
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
   const location = useLocation();


  const [leadDetails, setLeadDetails] = useState({
    leadstatus: "",
    donotdisturb: "",
    source: "",
    leadscore: "",
    dealname: "",
    dealvalue: "",
    won: "",
    lost: "",
  });

  useEffect(() => {
    reminders.forEach(scheduleNotification);
  }, []);

  const scheduleNotification = (reminder) => {
    const reminderTime = new Date(reminder.time).getTime();
    const currentTime = new Date().getTime();
    const timeDiff = reminderTime - currentTime;

    if (timeDiff > 0) {
      setTimeout(() => {
        showNotification(reminder.description);
      }, timeDiff);
    }
  };
  const showNotification = (message) => {
    if (Notification.permission === "granted") {
      new Notification("Reminder Alert", { body: message });
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          new Notification("Reminder Alert", { body: message });
        }
      });
    }
  };

  useEffect(() => {
    const fetchUserDetails = async () => {
      const token = localStorage.getItem("token");

      try {
        const res = await fetch(`${baseURL}/api/user`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();

        const selectedDetail = data.details.find((d) => d._id === id);
        if (selectedDetail) {
          setLeadDetails({
            leadstatus: selectedDetail.leadstatus,
            donotdisturb: selectedDetail.donotdisturb,
            source: selectedDetail.source,
            score: selectedDetail.leadscore,
            leadPeriod: selectedDetail.leadPeriod,
          });

          setSelectedLeadStatus(selectedDetail.leadstatus);
          setSelectedDND(selectedDetail.donotdisturb);
          setSelectedSource(selectedDetail.source);
          setDealName(selectedDetail.dealname || "");
          setDealValue(selectedDetail.dealvalue || "");
          setWonValue(selectedDetail.won || "");
          setLostValue(selectedDetail.lost || "");
          setScore(selectedDetail.leadscore || "");
          setLeadPeriod(selectedDetail.leadPeriod || "");
        }
      } catch (err) {
        console.error("Error fetching details:", err);
      }
    };

    fetchUserDetails();
  }, []);

  useEffect(() => {
    fetchCompany();
  }, []);

 
const fetchCompany = async () => {
  const token = localStorage.getItem("token");

  if (!token) {
    Swal.fire({
      icon: 'error',
      title: 'Authentication Required',
      text: 'No token found. Please login first.',
    });
    return;
  }

  if (!id) {
    console.error("Invalid ID:", id);
    Swal.fire({
      icon: 'warning',
      title: 'Invalid ID',
      text: 'No company ID provided.',
    });
    return;
  }

  try {
    const response = await fetch(
      `${baseURL}/api/company-details-with-employees/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = await response.json();

    if (response.ok) {
      setCompanyDetail(data.companyDetail);
      setEmployees(data.employees);
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Fetch Failed',
        text: data.message || "Company details not found.",
      });
    }
  } catch (error) {
    console.error("Error fetching company details:", error);
    Swal.fire({
      icon: 'error',
      title: 'Server Error',
      text: 'Something went wrong while fetching company details.',
    });
  }
};


  const now = new Date();
  const pad = (n) => (n < 10 ? "0" + n : n);
  const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}`;


const handleSaveReminder = async () => {
  const token = localStorage.getItem("token");

  if (!token) {
    Swal.fire({
      icon: 'error',
      title: 'Authentication Required',
      text: 'No token found. Please login first.',
    });
    return;
  }

  const companyName = companyDetail.companyname;
  console.log(companyName);

  if (!type || !subject || !description || !reminderTime) {
    Swal.fire({
      icon: 'warning',
      title: 'Missing Fields',
      text: 'Please fill in all the fields before saving the reminder.',
    });
    return;
  }

  try {
    const response = await axios.post(
      `${baseURL}/api/reminders`,
      {
        type,
        subject,
        description,
        time: reminderTime,
        detailId: id,
        companyName,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const newReminder = { type, subject, description, time: reminderTime };
    setReminders([...reminders, newReminder]);
    scheduleNotification(newReminder);

    // Clear form
    setType("");
    setSubject("");
    setDescription("");
    setReminderTime("");
    setShowPopup(false);

    Swal.fire({
      icon: "success",
      title: "Reminder Added",
      text: "Reminder Added Successfully",
      confirmButtonColor: "#FCB124",
      confirmButtonText: "OK",
    });
  } catch (error) {
    console.error("Error saving reminder:", error);
    Swal.fire({
      icon: 'error',
      title: 'Failed to Save Reminder',
      text: 'Something went wrong while saving the reminder. Please try again.',
    });
  }
};


  const handleUpdateReminder = async () => {
    const token = localStorage.getItem("token");
    if (!token || !selectedReminder) return;

    try {
      const response = await axios.put(
        `${baseURL}/api/reminders/${selectedReminder._id}`,
        {
          type,
          subject,
          description,
          time: reminderTime,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const updated = response.data.reminder;
      setReminders((prev) =>
        prev.map((rem) => (rem._id === updated._id ? updated : rem))
      );

      setModalIsOpen(false);

      Swal.fire({
        icon: "success",
        title: "Reminder Updated",
        text: "Reminder updated successfully",
        confirmButtonColor: "#FCB124",
      });
    } catch (error) {
      console.error("Error updating reminder:", error);
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "Could not update reminder",
      });
    }
  };

  const toggleTaskCompletion = async (index) => {
    const updatedReminders = [...reminders];
    const reminder = updatedReminders[index];
    const newStatus = reminder.status === "pending" ? "completed" : "pending";
    const token = localStorage.getItem("token");

    try {
      const response = await axios.put(
        `${baseURL}/api/reminders/status`,
        {
          reminderId: reminder._id,
          detailId: reminder.detailId,
          status: newStatus,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Update local reminder with response from server
      updatedReminders[index] = response.data.reminder;
      setReminders(updatedReminders);
    } catch (error) {
      console.error("Failed to update status", error);
    }
  };

  

const handleSaveNotes = async () => {
  const token = localStorage.getItem("token");

  if (!token) {
    Swal.fire({
      icon: 'error',
      title: 'Authentication Required',
      text: 'No token found. Please login first.',
    });
    return;
  }

  if (!notes.trim()) {
    Swal.fire({
      icon: 'warning',
      title: 'Empty Notes',
      text: 'Please enter a note before saving.',
    });
    return;
  }

  try {
    const response = await axios.post(
      `${baseURL}/api/notes`,
      {
        notes,
        detailId: id,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setNote((prevNotes) =>
      Array.isArray(prevNotes)
        ? [...prevNotes, response.data.notes]
        : [response.data.notes]
    );

    setNotes("");

    Swal.fire({
      icon: "success",
      title: "Notes Added",
      text: "Notes added successfully!",
      confirmButtonColor: "#FCB124",
      confirmButtonText: "OK",
    });
  } catch (error) {
    console.error("Error saving notes:", error);
    Swal.fire({
      icon: 'error',
      title: 'Save Failed',
      text: 'Something went wrong while saving your notes. Please try again.',
    });
  }
};


  useEffect(() => {
    fetchLists();
    fetchCompanyDetails();
  }, [listname, id]);

  const fetchLists = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "You need to login first",
      });
      return;
    }
    try {
      const response = await fetch(`${baseURL}/api/get-lists`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.ok) {
        if (data.lists && data.lists.length > 0) {
          // Ensure each list has _id
          const validatedLists = data.lists.map((list) => ({
            _id: list._id || new Date().getTime(),
            ...list,
          }));

          list.forEach((user) => console.log("User data:", user));

          setList(validatedLists);
          setSelectedList(validatedLists[0]);
        } else {
          console.warn("No lists found in response");
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.message || "Failed to fetch lists.",
        });
      }
    } catch (error) {
      console.error("Error fetching lists:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Error occured while fetching lists",
      });
    }
  };



const fetchCompanyDetails = async () => {
  const token = localStorage.getItem("token");

  if (!token) {
    Swal.fire({
      icon: 'error',
      title: 'Authentication Required',
      text: 'No token found. Please login first.',
    });
    return;
  }

  if (!id) {
    console.error("Invalid ID:", id);
    Swal.fire({
      icon: 'warning',
      title: 'Invalid Company ID',
      text: 'Company ID is missing or invalid.',
    });
    return;
  }

  try {

    const response = await fetch(`${baseURL}/api/company-details/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await response.json();

    if (response.ok) {
      setCompanyDetail(data);
    } else {
      console.warn("Primary fetch failed:", data.message);

      const listResponse = await fetch(
        `${baseURL}/api/getCompanyDetailsList/${listname}/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const listData = await listResponse.json();

      if (listResponse.ok) {
        setCompanyDetail(listData);
      } else {
        console.error("List fetch failed:", listData.message);
        Swal.fire({
          icon: 'error',
          title: 'Company Not Found',
          text: 'Company details could not be retrieved from either source.',
        });
      }
    }
  } catch (error) {
    console.error("Error fetching company details:", error);
    Swal.fire({
      icon: 'error',
      title: 'Server Error',
      text: 'An error occurred while fetching company details. Please try again later.',
    });
  }
};


  useEffect(() => {
    const fetchReminders = async () => {
      const token = localStorage.getItem("token");
      if (!token || !id) return;

      try {
        const response = await axios.get(`${baseURL}/api/reminders/${id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        setReminders(response.data.reminders);
      } catch (error) {
        console.error("Error fetching reminders:", error);
      }
    };

    fetchReminders();
  }, [id]);

 useEffect(() => {
  const fetchNotes = async () => {
    const token = localStorage.getItem("token");

    if (!token || !id) {
      Swal.fire({
        icon: 'error',
        title: 'Authentication Required',
        text: 'No token found or invalid ID. Please login.',
      });
      return;
    }

    try {
      const response = await axios.get(`${baseURL}/api/notes/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setNote(response.data.notes);
    } catch (error) {
      console.error("Error fetching notes:", error);
      Swal.fire({
        icon: 'error',
        title: 'Fetch Failed',
        text: 'Unable to fetch notes. Please try again later.',
      });
    }
  };

  fetchNotes();
}, [id]);

 const handleSaveEdit = async () => {
  if (!editNote.id || !editNote.text) {
    Swal.fire({
      icon: 'warning',
      title: 'Missing Data',
      text: 'Note ID or text is missing.',
    });
    return;
  }

  const token = localStorage.getItem("token");
  if (!token) {
    Swal.fire({
      icon: 'error',
      title: 'Authentication Required',
      text: 'No token found. Please login.',
    });
    return;
  }

  try {
    const response = await axios.put(
      `${baseURL}/api/notes/${editNote.id}`,
      { notes: editNote.text },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("Updated note:", response.data);

    setNote((prevNotes) =>
      prevNotes.map((n) =>
        n._id === editNote.id ? { ...n, notes: editNote.text } : n
      )
    );

    setIsModalOpen(false);
    setEditNote(null);

    Swal.fire({
      icon: 'success',
      title: 'Note Updated',
      text: 'Your note has been successfully updated.',
      confirmButtonColor: '#FCB124',
    });
  } catch (error) {
    console.error("Error updating note:", error);
    Swal.fire({
      icon: 'error',
      title: 'Update Failed',
      text: 'An error occurred while updating the note. Please try again.',
    });
  }
};
  const handleEdit = (id, noteText) => {
    if (!id) {
      console.error("Error: Note ID is missing");
      return;
    }
    setEditNote({ id, text: noteText || "" });
    setIsModalOpen(true);
  };

  const handleSubmit = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(`${baseURL}/api/user`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          detailId: id,
          leadstatus: selectedLeadStatus,
          donotdisturb: selectedDND,
          source: selectedSource,
          dealname: dealName,
          dealvalue: dealValue,
          won: wonValue,
          lost: lostValue,
          leadperiod: leadPeriod,
          notes: notes,
        }),
      });

      const data = await res.json();
      if (res.ok) {
        Swal.fire({
          icon:'success',
          title:'Updated successfully!',
          confirmButtonColor:'#FCB124'
        })
      } else {
       Swal.fire({
    icon: 'error',
    title: 'Action Failed',
    text: data.message || 'Something went wrong. Please try again.',
  });
      }
    } catch (err) {
      console.error("Error submitting:", err);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this note?"
    );
    if (!confirmDelete) return;

    const token = localStorage.getItem("token");
    try {
      await axios.delete(`${baseURL}/api/notes/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setNote((prev) => prev.filter((n) => n._id !== id));
      Swal.fire({
        icon: "success",
        title: "Notes Deleted",
        text: "Notes Deleted Successfully",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error("Error deleting note:", error);
    }
  };

const downloadPDF = () => {

  if (!companyDetail || !companyDetail.companyname) {
    Swal.fire({
      icon: 'warning',
      title: 'No Company Selected',
      text: 'Please select a company before downloading.',
    });
    return; 
  }

  const doc = new jsPDF();
  let y = 10;

  doc.setFont("Times", "bold");
  doc.setFontSize(16);
  doc.text("Company Profile Report", 14, y);
  y += 10;

  doc.setFontSize(12);
  doc.text(`Company Name: ${companyDetail.companyname || "N/A"}`, 14, y); y += 10;
  doc.text(`Email: ${companyDetail.email || "N/A"}`, 14, y); y += 10;
  doc.text(`City: ${companyDetail.city || "N/A"}`, 14, y); y += 10;
  doc.text(`State: ${companyDetail.state || "N/A"}`, 14, y); y += 10;
  doc.text(`Country: ${companyDetail.country || "N/A"}`, 14, y); y += 10;
  doc.text(`Phone: ${companyDetail.phonenumber || "N/A"}`, 14, y); y += 10;
  doc.text(`Industry: ${companyDetail.industry || "N/A"}`, 14, y); y += 10;
  doc.text(`Website: ${companyDetail.website || "N/A"}`, 14, y); y += 10;
  doc.text(`Technology: ${companyDetail.technologyname || "N/A"}`, 14, y); y += 10;
  doc.text(`Technology Description: ${companyDetail.technologydescription || "N/A"}`, 14, y); y += 10;
  doc.text(`Financial: ${companyDetail.financial || "N/A"}`, 14, y); y += 10;
  doc.text(`Financial Description: ${companyDetail.financialdescription || "N/A"}`, 14, y); y += 10;
  doc.text(`Financial Source Link: ${companyDetail.financialsourcelink || "N/A"}`, 14, y); y += 10;
  doc.text(`Financial Year: ${companyDetail.financialyear || "N/A"}`, 14, y); y += 10;

  doc.setFont("Times", "bold");
  doc.text("Business Description:", 14, y);
  y += 5;

  doc.setFont("Times", "normal");
  let splitDescription = doc.splitTextToSize(companyDetail.companydescription || "N/A", 180);
  doc.text(splitDescription, 14, y);
  y += splitDescription.length * 7;

  doc.save(`${companyDetail.companyname}_Profile.pdf`);
};

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  const leadStatusScoreMap = {
    Lead: "10%",
    "Qualified Lead": "30%",
    Prospect: "50%",
    "Most Prospective": "80%",
    Customer: "100%",
  };

  const leadStatusPeriodMap = {
    Lead: "6 months",
    "Qualified Lead": "3 months",
    Prospect: "4 months",
    "Most Prospective": "3 months",
  };

  const handleLeadStatusChange = (e) => {
    const status = e.target.value;
    const scoreValue = leadStatusScoreMap[status] || "";
    const periodValue = leadStatusPeriodMap[status] || "";

    setSelectedLeadStatus(status);
    setScore(scoreValue);
    setLeadPeriod(periodValue);

    if (status === "Won") {
      setWonValue(dealValue);
      setLostValue("");
    } else if (status === "Lost") {
      setLostValue(dealValue);
      setWonValue("");
    } else {
      setWonValue("");
      setLostValue("");
    }
  };

  const handleViewStatus = () => {
    navigate("/deals");
  };

  const handleBack = () => {
      if (location.state?.from === "my-list" && location.state?.listName) {
      navigate(`/my-list/${location.state.listName}`);
    } else {
      navigate("/my-contacts");
    }
  };

  return (
    <>
      <Header />
      <div className="company-page">
        <button onClick={handleBack} className="company-back">
          <MdOutlineArrowBackIos/><h4>Back</h4>
        </button>
        {companyDetail ? (
          <div className="company-head-detail">
            <div className="head-details">
              <div className="com-det">
                <div className="companyname">
                  {" "}
                  {companyDetail.companyname}{" "}
                  <span className="Linkedin">
                    <a
                      href={companyDetail.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        textDecoration: "none",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <FaLinkedin
                        className="linkedin"
                        style={{ color: "#0056b3", fontSize: "18px" }}
                      />
                    </a>
                  </span>
                </div>
                {/* <div className='about-company'>About this company</div> */}
                {companyDetail.website && (
                  <div className="company-ind">
                    Website:
                    <a
                      href={companyDetail.website}
                      className="company-website"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ paddingLeft: "5px" }}
                    >
                      {companyDetail.website}
                    </a>
                  </div>
                )}

                {/* <div className='company-ind'>Industry:<span className='industry'>{companyDetail.industry}</span></div> */}
                {/* {companyDetail?.noofemployees && ( <div className='company-ind'>No of Employees:<span className='industry'>{companyDetail.noofemployees}</span></div>)} */}
                <div className="company-address">
                  <p>{companyDetail.headquarter}</p>
                  <p>{companyDetail.phonenumber}</p>
                  {/* <p>{companyDetail.state} {companyDetail.country}</p>
              {/* <div className='company-ind'>Email: <span className='company-email'>{companyDetail.email}</span></div> */}
                  {/* <div className='company-ind'>Contact:<span className='industry'>{companyDetail.phonenumber}</span></div> */}
                </div>
              </div>
            </div>
            <div className="lead">
              <div>Lead Status</div>
              <div className="data">{leadDetails.leadstatus || "N/A"}</div>
            </div>

            <div className="lead">
              <div>Do Not Disturb</div>
              <div className="data">{leadDetails.donotdisturb || "N/A"}</div>
            </div>

            <div className="lead">
              <div>Source</div>
              <div className="data">{leadDetails.source || "N/A"}</div>
            </div>

            <div className="lead">
              <div>Score</div>
              <div className="data">{score || "N/A"}</div>
            </div>

            <IoMdDownload
              onClick={() => downloadPDF(id)}
              className="down-icon"
            />
          </div>
        ) : (
          <p>Loading company details...</p>
        )}
        <div className="company-details-head">
          {[
            "Overview",
            "Job Openings",
            "News and Social Insights",
            "Decision Makers",
            "Status",
            "Activities",
          ].map((tab) => (
            <nav
              key={tab}
              className={`company-nav ${
                selectedTab === tab ? "active-tab" : ""
              }`}
              onClick={() => handleTabClick(tab)}
            >
              {tab}
            </nav>
          ))}
        </div>

        <div>
          <div className="company-content">
            {selectedTab === "Overview" && (
              <>
                <div className="company-details-container">
                  <div className="company-columns">
                    {/* Column 1 */}
                    <div className="company-col">
                      {companyDetail?.companydescription && (
                        <div className="company-card1">
                          <h3>Description</h3>
                          <p>{companyDetail.companydescription}</p>
                        </div>
                      )}
                      {companyDetail?.website && (
                        <div className="company-card1">
                          <h3>URL:</h3>{" "}
                          <a
                            href={companyDetail.website}
                            className="company-link"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {companyDetail.website}
                          </a>
                        </div>
                      )}
                      {companyDetail?.email && (
                        <div className="company-card1">
                          <h3>Email:</h3>{" "}
                          <span className="company-email">
                            {companyDetail.email}
                          </span>
                        </div>
                      )}
                    </div>

                    {/* Column 2 */}
                    <div className="company-col">
                      {companyDetail?.industry && (
                        <div className="company-card">
                          <h3>Industry</h3>
                          <p>{companyDetail.industry}</p>
                        </div>
                      )}
                      {companyDetail?.headquarter && (
                        <div className="company-card">
                          <h3>Headquarters</h3>
                          <p>{companyDetail.headquarter}</p>
                        </div>
                      )}
                      {companyDetail?.noofemployees && (
                        <div className="company-card">
                          <h3>No of Employees</h3>
                          <p>{companyDetail.noofemployees}</p>
                        </div>
                      )}
                      {companyDetail?.competitors && (
                        <div className="company-card">
                          <h3 className="company-details-header">
                            Competitors
                          </h3>
                          <p className="company-details-table">
                            {Array.isArray(companyDetail.competitors)
                              ? companyDetail.competitors.join(", ")
                              : JSON.stringify(companyDetail.competitors)}
                          </p>
                        </div>
                      )}
                      {companyDetail?.investors &&
                        companyDetail.investors.length > 0 && (
                          <div className="company-card1">
                            <h3>Investors</h3>
                            {companyDetail.investors.map((inv, index) => (
                              <div key={index}>
                                <p>
                                  <strong>Investor:</strong> {inv.investors}
                                </p>
                                {inv.sourcelink && (
                                  <p>
                                    <a
                                      href={inv.sourcelink}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {inv.sourcelink}
                                    </a>
                                  </p>
                                )}
                              </div>
                            ))}
                          </div>
                        )}

                      {companyDetail?.financial &&
                        companyDetail.financial.length > 0 && (
                          <div className="company-card1">
                            <h3>Financial</h3>
                            {companyDetail.financial.map((fin, index) => (
                              <div key={index}>
                                {fin.financialdescription && (
                                  <p> {fin.financialdescription}</p>
                                )}
                                {fin.financialsourcelink && (
                                  <p>
                                    {" "}
                                    <a
                                      href={fin.financialsourcelink}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {fin.financialsourcelink}
                                    </a>
                                  </p>
                                )}
                                {fin.financialyear && (
                                  <p>
                                    <strong>Year:</strong> {fin.financialyear}
                                  </p>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                    </div>
                    {/* Column 3 */}
                    <div className="company-col">
                      {companyDetail?.technologydetails && (
                        <div className="company-card1">
                          <h3>Technology</h3>
                          <div>
                            <p> {companyDetail.technologydetails}</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          {selectedTab === "Job Openings" && (
            <>
              <h3 style={{ textAlign: "center" }}>Job Openings</h3>
              <div>
                {companyDetail.jobopenings &&
                companyDetail.jobopenings.length > 0 ? (
                  companyDetail.jobopenings.map((job, index) => (
                    <div className="job-openings-section" key={index}>
                      <div>
                        {job.jobname && (
                          <div className="job">
                            💼 {job.jobname} <span className="Linkedin"></span>
                          </div>
                        )}
                        {job.jobdescription && (
                          <div className="job-company">
                            🏢 {job.jobdescription}
                          </div>
                        )}
                        {job.jobsource && (
                          <div
                            className="job-link"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            ℹ️ {job.jobsource.length > 20
                                  ? `${job.jobsource.slice(0, 40)}...`
                                  : job.jobsource}
                          </div>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <div>
                    <h3 style={{ textAlign: "center" }}>Not Available</h3>
                  </div>
                )}
              </div>
            </>
          )}

          {selectedTab === "News and Social Insights" && (
            <>
              <h3 style={{ textAlign: "center" }}>
                📰 News and Social Insights
              </h3>
              <div className="news-section">
                <div className="job-openings-section">
                  {companyDetail.newsandsocialinsights &&
                  companyDetail.newsandsocialinsights.length > 0
                    ? companyDetail.newsandsocialinsights.map((news, index) => (
                        <div key={index}>
                          <div className="job">{news.newsname}</div>
                          <div className="job-company">
                            {news.newsdescription}
                          </div>
                          <div className="job-link">{news.newssource}</div>
                        </div>
                      ))
                    : "Not Available"}
                </div>
              </div>
            </>
          )}

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <div>
              {selectedTab === "Activities" && (
                <>
                  <div className="task-container">
                    <h3 className="task-title" style={{ textAlign: "center" }}>
                      Task
                    </h3>
                    <button
                      className="task-add-btn"
                      onClick={() => setShowPopup(true)}
                    >
                      <FaPlus /> Add
                    </button>
                    <ul className="task-list" style={{ fontSize: "24px" }}>
                      {reminders.length > 0 ? (
                        [...reminders]
                          .sort((a, b) => new Date(a.time) - new Date(b.time))
                          .map((reminder, index) => {
                            const formattedTime = new Date(
                              reminder?.time
                            ).toLocaleString("en-US", {
                              month: "short",
                              day: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            });

                            const isCompleted = reminder.status === "completed";

                            return (
                              <li
                                key={reminder._id || index}
                                className={`task-item ${
                                  isCompleted ? "completed" : ""
                                }`}
                              >
                                {/* <button
            className="task-check"
           
          >
            {isCompleted ? <MdCheckCircle className="checked" /> : <MdRadioButtonUnchecked />}
          </button> */}
                                <div className="task-icon">
                                  {(() => {
                                    const now = new Date();
                                    const reminderTime = new Date(
                                      reminder?.time
                                    );
                                    const isOverdue =
                                      reminder.status !== "completed" &&
                                      reminderTime < now;

                                    let icon = null;
                                    let color = "";

                                    if (reminder.type === "Meeting") {
                                      icon = <MdGroups />;
                                    } else if (reminder.type === "Call") {
                                      icon = <MdCall />;
                                    } else if (reminder.type === "Email") {
                                      icon = <MdEmail />;
                                    }

                                    if (isOverdue) {
                                      color = "red";
                                      icon = (
                                        <span
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "4px",
                                            color,
                                          }}
                                        >
                                          {icon}
                                          <span style={{ fontWeight: "bold" }}>
                                            <MdErrorOutline />
                                          </span>
                                        </span>
                                      );
                                    } else {
                                      color =
                                        reminder.status === "completed"
                                          ? "green"
                                          : "orange";
                                      icon = (
                                        <span style={{ color }}>{icon}</span>
                                      );
                                    }

                                    return icon;
                                  })()}
                                </div>

                                <div className="task-details">
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <span
                                      className="task-desc"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedReminder(reminder);
                                        setType(reminder.type || "");
                                        setSubject(reminder.subject || "");
                                        setDescription(
                                          reminder.description || ""
                                        );
                                        setReminderTime(reminder.time || "");
                                        setId(reminder.id);
                                        setModalMode("view");
                                        setModalIsOpen(true);
                                      }}
                                    >
                                      {reminder?.subject || "No Subject"}
                                    </span>

                                    {!isCompleted && (
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          toggleTaskCompletion(index);
                                        }}
                                        style={{
                                          padding: "4px 8px",
                                          fontSize: "12px",
                                          backgroundColor: "#fcb124",
                                          color: "#fff",
                                          border: "none",
                                          borderRadius: "4px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        Mark as Completed
                                      </button>
                                    )}
                                  </div>

                                  <span
                                    className={`task-date ${
                                      isCompleted
                                        ? "completed-date"
                                        : "pending-date"
                                    }`}
                                  >
                                    Reminder at {formattedTime}
                                  </span>
                                </div>
                              </li>
                            );
                          })
                      ) : (
                        <li style={{ fontSize: "12px" }}>
                          No reminders available
                        </li>
                      )}
                    </ul>

                    <ReactModal
                      isOpen={modalIsOpen}
                      onRequestClose={() => setModalIsOpen(false)}
                      className="task-modal"
                      overlayClassName="modal-overlay"
                      ariaHideApp={false}
                    >
                      {selectedReminder && (
                        <div className="popup-form">
                          <h1 className="reminderHeader">
                            <MdNotificationsActive
                              size={20}
                              style={{ marginRight: 8 }}
                            />
                            Reminder
                          </h1>

                          {modalMode === "edit" ? (
                            <>
                              <select
                                value={type}
                                onChange={(e) => setType(e.target.value)}
                              >
                                <option value="">Select Type</option>
                                <option value="Meeting">Meeting</option>
                                <option value="Call">Call</option>
                                <option value="Email">Email</option>
                              </select>

                              <input
                                type="text"
                                placeholder="Subject"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                              />
                              <input
                                type="text"
                                placeholder="Description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                              />

                              <label htmlFor="date">Date & Time</label>
                              <input
                                className="date-input"
                                type="datetime-local"
                                id="date"
                                value={reminderTime}
                                onChange={(e) =>
                                  setReminderTime(e.target.value)
                                }
                                required
                              />

                              <div className="popup-buttons">
                                <button
                                  className="task-save"
                                  onClick={handleUpdateReminder}
                                >
                                  Save
                                </button>
                                <button
                                  className="task-cancel"
                                  onClick={() => setModalIsOpen(false)}
                                >
                                  Cancel
                                </button>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="view-container">
                                <p>
                                  <strong>Type:</strong>{" "}
                                  {selectedReminder.type || "N/A"}
                                </p>
                                <p>
                                  <strong>Subject:</strong>{" "}
                                  {selectedReminder.subject || "N/A"}
                                </p>
                                <p>
                                  <strong>Description:</strong>{" "}
                                  {selectedReminder.description || "N/A"}
                                </p>
                                <p>
                                  <strong>Date & Time:</strong>{" "}
                                  {new Date(
                                    selectedReminder.time
                                  ).toLocaleString()}
                                </p>
                                <p>
                                  <strong>Status:</strong>{" "}
                                  {selectedReminder.status}
                                </p>
                              </div>
                              <div className="popup-buttons">
                                <button
                                  className="task-save"
                                  onClick={() => setModalMode("edit")}
                                >
                                  Edit
                                </button>
                                <button
                                  className="task-cancel"
                                  onClick={() => setModalIsOpen(false)}
                                >
                                  Close
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      )}
                    </ReactModal>

                    {showPopup && (
                      <div
                        className="popup-overlay"
                        onClick={(e) => handleOutsideClick(e)}
                      >
                        <div
                          className="popup"
                          ref={popupRef}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <h3>Add Reminder</h3>

                          <select
                            id="type"
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                            className="reminder-select"
                          >
                            <option value="">Select Type</option>
                            <option value="Meeting">Meeting</option>
                            <option value="Call">Call</option>
                            <option value="Email">Email</option>
                          </select>

                          <input
                            className="reminder-input"
                            type="text"
                            placeholder="Subject"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            required
                          />

                          <input
                            className="reminder-input"
                            type="text"
                            placeholder="Description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            required
                          />

                          <label htmlFor="date">Date & Time</label>
                          <input
                            className="reminder-input"
                            type="datetime-local"
                            id="date"
                            name="date"
                            min={today} 
                            value={reminderTime}
                            onChange={(e) => setReminderTime(e.target.value)}
                            required
                          />

                          <button
                            className="task-save"
                            onClick={handleSaveReminder}
                          >
                            Save
                          </button>
                          <button
                            className="task-cancel"
                            onClick={() => setShowPopup(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
            <div>
              {selectedTab === "updates" && (
                <>
                  <h3 style={{ textAlign: "center" }}>Updates</h3>
                  <ul className="notes-list">
                    {reminders
                      .filter((reminder) => reminder.status === "completed")
                      .sort((a, b) => new Date(a.time) - new Date(b.time))
                      .map((reminder, index) => {
                        return (
                          <li key={reminder._id || index} className="note-item">
                            <div className="note-content">
                              <div>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "10px",
                                    fontWeight: "500",
                                    marginBottom: "4px",
                                    color: "#4CAF50", // Green for completed
                                  }}
                                >
                                  <div>{reminder.description}</div>
                                  <div
                                    style={{
                                      fontWeight: "500",
                                      marginBottom: "4px",
                                      color: "#4CAF50",
                                    }}
                                  >
                                    {reminder.status}
                                  </div>
                                </div>

                                {/* Show completed time */}
                                {reminder.completedAt && (
                                  <div style={{ color: "#555" }}>
                                    Completed on{" "}
                                    {new Date(
                                      reminder.completedAt
                                    ).toLocaleString("en-US", {
                                      month: "short",
                                      day: "2-digit",
                                      year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    })}
                                  </div>
                                )}
                              </div>
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </>
              )}
            </div>
          </div>
          {selectedTab === "Notes" && (
            <>
              <h3 style={{ textAlign: "center" }}>Notes</h3>
              <button className="task-add-btn" onClick={handleSaveNotes}>
                <FaPlus />
              </button>
              <textarea
                className="notes-textarea"
                placeholder="Notes"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                required
              ></textarea>
              <ul className="notes-list">
                {Array.isArray(note) && note.length > 0 ? (
                  note.map((note, index) => (
                    <li key={index} className="note-item">
                      <div className="note-content">
                        <span className="task-desc">
                          {note?.notes || "No Notes"}
                        </span>
                        <div className="note-actions">
                          <button
                            onClick={() => {
                              console.log("Editing Note:", note);
                              handleEdit(note?._id, note?.notes);
                            }}
                            className="edit-btn"
                          >
                            <MdEdit />
                          </button>

                          <button
                            onClick={() => handleDelete(note._id)}
                            className="delete-btn"
                          >
                            <MdDelete />
                          </button>
                        </div>
                      </div>
                    </li>
                  ))
                ) : (
                  <li className="note-item2">Create Your Notes</li>
                )}
              </ul>

              {isModalOpen && (
                <div className="modal">
                  <div className="modal-content">
                    <h3>Edit Note</h3>
                    <textarea
                      className="edit-textarea"
                      value={editNote.text}
                      onChange={(e) =>
                        setEditNote({ ...editNote, text: e.target.value })
                      }
                      required
                    ></textarea>
                    <button className="editsave-btn" onClick={handleSaveEdit}>
                      Save
                    </button>
                    <button
                      className="edit-cancel-btn"
                      onClick={() => setIsModalOpen(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}
            </>
          )}

          {selectedTab === "Status" && (
            <>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "20px",
                  padding: "0 20px",
                  marginLeft: "150px",
                }}
              >
                <div>
                  <label className="label">Deal Name</label>
                  <input
                    className="deal-input1"
                    type="text"
                    placeholder="Deal Name"
                    value={dealName}
                    onChange={(e) => setDealName(e.target.value)}
                  />
                </div>

                <div>
                  <label className="label">Currency</label>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <select style={{ width: "120px" }}>
                      <option>USD</option>
                      <option>INR</option>
                      <option>EUR</option>
                    </select>
                    <input
                      className="deal-input"
                      type="number"
                      placeholder="Deal Value"
                      value={dealValue}
                      onChange={(e) => setDealValue(e.target.value)}
                    />
                  </div>
                </div>

                <div>
                  <label className="label">Lead Status</label>
                  <select
                    className="deal-input2"
                    value={selectedLeadStatus}
                    onChange={handleLeadStatusChange}
                  >
                    <option value="">Select Status</option>
                    <option value="Lead">Lead</option>
                    <option value="Qualified Lead">Qualified Lead</option>
                    <option value="Prospect">Prospect</option>
                    <option value="Most Prospective">Most Prospective</option>
                    <option value="Customer">Customer</option>
                    <option value="Won">Won</option>
                    <option value="Lost">Lost</option>
                  </select>
                </div>

                <div>
                  <label className="label">Source</label>
                  <select
                    className="deal-input2"
                    value={selectedSource}
                    onChange={(e) => setSelectedSource(e.target.value)}
                  >
                    <option value="">Select Source</option>
                    <option value="Email Campaign">Email Campaign</option>
                    <option value="Networking">Networking</option>
                    <option value="Reference">Reference</option>
                    <option value="LinkedIn">LinkedIn</option>
                    <option value="Cold Calling">Cold Calling</option>
                    <option value="Inbound">Inbound</option>
                    <option value="Social Media">Social Media</option>
                  </select>
                </div>

                <div>
                  <label className="label">Do Not Disturb</label>
                  <select
                    className="deal-input2"
                    value={selectedDND}
                    onChange={(e) => setSelectedDND(e.target.value)}
                  >
                    <option value="">Select Option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
                <textarea
                  className="notes-textarea"
                  placeholder="Notes"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                ></textarea>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "20px",
                }}
              >
                <button className="deal-save" onClick={handleSubmit}>
                  Submit
                </button>
              </div>

              {selectedLeadStatus === "Won" && (
                <p style={{ color: "green" }}>
                  Deal marked as Won: {dealValue}
                </p>
              )}
              {selectedLeadStatus === "Lost" && (
                <p style={{ color: "red" }}>Deal marked as Lost: {dealValue}</p>
              )}
            </>
          )}

          {selectedTab === "Decision Makers" && (
            <>
              {employees?.length > 0 && (
                <div className="decision-maker">
                  <h3 style={{ textAlign: "center" }}>Company Employees</h3>
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Designation</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {employees.map((emp, index) => (
                        <tr key={index}>
                          <td>{emp.name}</td>
                          <td>{emp.designation}</td>
                          <td>
                            <button
                              className="btn"
                              onClick={() => handleTabClick("Status")}
                            >
                              Add Status
                            </button>
                            <button
                              className="btn"
                              onClick={() =>
                                handleViewStatus(
                                  emp.companyname || companyDetail.companyname
                                )
                              }
                            >
                              View Status
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default CompanyPage;